"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasKey = void 0;

var _is = require("../is/is");

var _hasKey = function _hasKey(key, source) {
  return (0, _is.is)(source) && Object.prototype.hasOwnProperty.call(source, key);
};

var hasKey = function hasKey() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  // @signature (key) => (source)
  if (params.length <= 1) {
    return function (source) {
      return _hasKey(params[0], source);
    };
  } // @signature (key, source)


  return _hasKey.apply(void 0, params);
};

exports.hasKey = hasKey;